import Home from "@pages/Home";
import Login from "../../pages/Login";
import AppLayout from "@layouts/AppLayout";
import EmptyLayout from "@layouts/EmptyLayout";
import UserList from "@pages/UserListManagement/List/UserList";
import Orders from "@pages/Order/List/Order";
import PaymentUserDetails from "@components/paymentUserDetails/PaymentUser";
import HomePage from "@pages/Home/HomePage/homepage";
import PopupManagement from "@pages/PopupManagement/PopupList";
import CreatePopup from "@components/CreatePopup/CreatePopup";
import HeaderPopup from "@components/CreatePopup/headerPopup/headerPopup";
import CenterPopup from "@components/CreatePopup/centerPopup/centerPopup";
import BottomPopup from "@components/CreatePopup/bottomPopup/bottomPopup";
import BrowseImage from "@pages/BrowseImage/BrowseImage";
import QrScanMonitor from "@pages/QrScanMonitor/QrScanMonitor";
import UrlScanReview from "@pages/UrlScanReview/UrlScanReview";
import AdminAccountManagement from "@pages/AdminAccountManagement";
import ServicePackageManagement from "@pages/ServicePackageManagement";

const ROUTES = [
    {
        label: "Home",
        path: "/admin/language-management",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: Home,
        layout: AppLayout,
    },
    {
        label: "Login",
        path: "/login",
        exact: true,
        isPrivate: false,
        authenticatedRedirect: true,
        component: Login,
        layout: EmptyLayout,
    },
    {
        label: "User-manager",
        path: "/admin/user-management",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: UserList,
        layout: AppLayout,
    },
    {
        label: "Order-manager",
        path: "/admin/order-management",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: Orders,
        layout: AppLayout,
    },
    {
        label: "QR-scan-monitor",
        path: "/admin/qr-scan-monitor",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: QrScanMonitor,
        layout: AppLayout,
    },
    {
        label: "Url-scan-review",
        path: "/admin/url-scan-review",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: UrlScanReview,
        layout: AppLayout,
    },
    {
        label: "Service-package-management",
        path: "/admin/service-package-management",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: ServicePackageManagement,
        layout: AppLayout,
    },
    {
        label: "Admin-account-management",
        path: "/admin/admin-account-management",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: AdminAccountManagement,
        layout: AppLayout,
    },
    {
        label: "Home-page",
        path: "/",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: true,
        component: HomePage,
        layout: AppLayout,
    },
    {
        label: "popup-manager",
        path: "/admin/popup-management",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: true,
        component: PopupManagement,
        layout: AppLayout,
    },
    {
        label: "payment-info",
        path: "/payment-customer/:id",
        exact: false,
        isPrivate: true,
        authenticatedRedirect: true,
        component: PaymentUserDetails,
        layout: EmptyLayout,
    },
    {
        label: "popup-create",
        path: "/admin/create-popup",
        exact: false,
        isPrivate: true,
        authenticatedRedirect: true,
        component: CreatePopup,
        layout: EmptyLayout,
    },
    {
        label: "popup-create-header",
        path: "/admin/create-popup/header/",
        exact: false,
        isPrivate: true,
        authenticatedRedirect: true,
        component: HeaderPopup,
        layout: EmptyLayout,
    },
    {
        label: "popup-create-center",
        path: "/admin/create-popup/center/",
        exact: false,
        isPrivate: true,
        authenticatedRedirect: true,
        component: CenterPopup,
        layout: EmptyLayout,
    },
    {
        label: "popup-create-bottom",
        path: "/admin/create-popup/bottom/",
        exact: false,
        isPrivate: true,
        authenticatedRedirect: true,
        component: BottomPopup,
        layout: EmptyLayout,
    },
    {
        label: "Browser",
        path: "/browse-image",
        exact: true,
        isPrivate: true,
        authenticatedRedirect: false,
        component: BrowseImage,
        layout: EmptyLayout,
        //   higherPermissions: false,
    },
    {
        label: "Not-found",
        path: "*",
        exact: false,
        isPrivate: true,
        authenticatedRedirect: false,
        component: HomePage,
        layout: AppLayout,
    },
];

export default ROUTES;
